"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortBy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_ui_1 = require("@yanzi/react-ui");
const lodash_1 = require("lodash");
const react_1 = require("react");
function useSortBy(values, { defaultSortKey = null, defaultSortOrder = 'asc', }) {
    const [sortKey, setSortKey] = react_1.useState(defaultSortKey);
    const [sortOrder, setSortOrder] = react_1.useState(defaultSortOrder);
    const handleHeaderClick = react_1.useCallback((key) => {
        if (sortKey === key) {
            setSortOrder(old => (old === 'desc' ? 'asc' : 'desc'));
        }
        else {
            setSortKey(key);
            setSortOrder(defaultSortOrder);
        }
    }, [defaultSortOrder, sortKey]);
    const sorted = react_1.useMemo(() => {
        if (!values) {
            return null;
        }
        if (sortKey === null) {
            return values;
        }
        return lodash_1.orderBy(values, value => { var _a; return (_a = value[sortKey]) !== null && _a !== void 0 ? _a : 0; }, sortOrder);
    }, [sortKey, sortOrder, values]);
    const getArrowComponent = react_1.useCallback((key) => {
        if (sortKey !== key) {
            return null;
        }
        if (sortOrder === 'desc') {
            return jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronUp }, void 0);
        }
        return jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown }, void 0);
    }, [sortKey, sortOrder]);
    const getThProps = react_1.useCallback(function (key, mergeProps = {}) {
        var _a;
        const arrowComponent = getArrowComponent(key);
        const { key: throwAway } = mergeProps, props = __rest(mergeProps, ["key"]);
        return Object.assign(Object.assign({}, props), { onClick: (e) => {
                var _a;
                handleHeaderClick(key);
                (_a = mergeProps.onClick) === null || _a === void 0 ? void 0 : _a.call(mergeProps, e);
            }, style: Object.assign(Object.assign({}, ((_a = mergeProps.style) !== null && _a !== void 0 ? _a : {})), clickableThStyle), children: (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [mergeProps.children, arrowComponent ? (jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ display: "inline-block", ml: 2 }, { children: arrowComponent }), void 0)) : null] }, void 0)) });
    }, [getArrowComponent, handleHeaderClick]);
    return react_1.useMemo(() => ({ sortKey, sortOrder, data: sorted, handleHeaderClick, getArrowComponent, getThProps }), [handleHeaderClick, getArrowComponent, sortKey, sortOrder, sorted, getThProps]);
}
exports.useSortBy = useSortBy;
const clickableThStyle = { cursor: 'pointer', userSelect: 'none' };
//# sourceMappingURL=useSortBy.js.map